// extracted by mini-css-extract-plugin
export default {"main":"App_main__5VZ13","_body":"App__body__fJp47"};